import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { Relationship } from "../utils/types/shifting";

export const fetchShiftingMatrixData = async (sort?: {
  field: string;
  direction: string | null | undefined;
}) => {
  const response = await axiosServices.get("/shiftingmatrix", {
    params: {
      sort: sort
        ? JSON.stringify([{ property: sort.field, direction: sort.direction }])
        : '[{"property":"id","direction":"ASC"}]',
    },
  });
  return convertToCamelCase<Relationship[]>(response.data.data);
};

export const updateShiftingMatrixData = async (
  id: string,
  data: {
    [key: string]: any;
    shiftingMatrixId: string;
  }
) => {
  const inputData = convertToSnakeCase(data);
  await axiosServices.put(`/shiftingmatrix/${id}`, inputData);
  return {
    success: true,
    data,
  };
};

export const deleteShiftingMatrixData = async (id: string) => {
  const response = await axiosServices.delete(`/shiftingmatrix/${id}`);
  return { success: response.data.success, id };
};

export const addRelationShipData = async (data: { [key: string]: any }) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(`/shiftingmatrix`, inputData);
  return convertToCamelCase<Relationship>(response.data.data);
};
